import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Autocomplete from "@material-ui/lab/Autocomplete";
import LabelsContext from "../../../lang/LabelsContext";
import KeywordsDto from "../../../model/keywords/KeywordsDto";
import ArticleCard from "../article-card/ArticleCard";
import SearchManuscriptsService, { SearchManuscriptsServiceType } from "./SearchManuscriptsService";
import useStyles from "./SearchManuscriptsStyle";

export default function SearchManuscripts() {
  const classes = useStyles();
  const { Labels } = LabelsContext();
  const {
    value,
    setValue,
    handleChange,
    reviewStatusList,
    keywordsList,
    searchManuscripts,
    articles,
    authorList,
    typeList,
    associateEditorList,
    activeOptions,
    uplaodUserList,
    handleChangeActive,
    handleChangeReviewStatus,
  }: SearchManuscriptsServiceType = SearchManuscriptsService();

  const dataView = (data: any) => {
    return (
      <Grid container spacing={2}>
        {data}
      </Grid>
    );
  };

  const resultView = (array: any) => {
    if (!array) {
      return;
    }
    if (array.length === 0) {
      return dataView(<Typography color="textSecondary">{Labels.NO_RESULTS}</Typography>);
    }
    return dataView(
      array.map((data: any, i: number) => (
        <Grid item xs={12} sm={12}>
          <ArticleCard data={data} index={i} animation={true} />
        </Grid>
      ))
    );
  };

  return (
    <>
      <CssBaseline />
      <Paper className={classes.paper}>
        <Typography component="h1" variant="h4" align="center">
          {Labels.SEARCH}
        </Typography>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={2}>
            <TextField
              variant="outlined"
              margin="normal"
              name="articleId"
              value={value.articleId}
              onChange={handleChange}
              label={Labels.ARTICLE_ID}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              variant="outlined"
              margin="normal"
              name="title"
              value={value.title}
              onChange={handleChange}
              label={Labels.TITLE}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              className={classes.multiselect}
              id="keyword"
              value={value.keyword}
              onChange={(event, newValue) => setValue({ ...value, keyword: newValue })}
              options={keywordsList}
              getOptionLabel={(option: KeywordsDto) => option.keyword}
              filterSelectedOptions
              renderInput={(params: any) => <TextField {...params} variant="outlined" label={Labels.KEYWORD} />}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              className={classes.multiselect}
              id="active"
              value={value.activeArticle}
              onChange={(event, newValue) => handleChangeActive(newValue)}
              options={activeOptions}
              getOptionLabel={(option: any) => option.name}
              filterSelectedOptions
              renderInput={(params: any) => (
                <TextField {...params} variant="outlined" label={Labels.ACTIVE_MANUSCRIPT} />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              multiple
              limitTags={1}
              fullWidth
              className={classes.multiselect}
              id="reviewStatus"
              value={value.reviewStatus}
              onChange={(event, newValue) => handleChangeReviewStatus(newValue)}
              options={
                value.reviewStatus
                  ? reviewStatusList.filter((x: any) => !value.reviewStatus.some((y: any) => y.id === x.id))
                  : reviewStatusList
              }
              getOptionLabel={(option: any) => option.title}
              renderInput={(params: any) => <TextField {...params} variant="outlined" label={Labels.ARTICLE_STATUS} />}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              className={classes.multiselect}
              id="type"
              value={value.keyword}
              onChange={(event, newValue) => setValue({ ...value, type: newValue })}
              options={typeList}
              getOptionLabel={(option: any) => option.name}
              filterSelectedOptions
              renderInput={(params: any) => <TextField {...params} variant="outlined" label={Labels.TYPE} />}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              fullWidth
              className={classes.multiselect}
              id="reviewStatus"
              value={value.author}
              onChange={(event, newValue) => setValue({ ...value, author: newValue })}
              options={authorList}
              getOptionLabel={(option: any) => option.firstName + " " + option.lastName}
              filterSelectedOptions
              renderInput={(params: any) => <TextField {...params} variant="outlined" label={Labels.AUTHOR} />}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              fullWidth
              className={classes.multiselect}
              id="associateEditorId"
              value={value.associateEditorId}
              onChange={(event, newValue) => setValue({ ...value, associateEditorId: newValue })}
              options={associateEditorList}
              getOptionLabel={(option: any) => option.firstName + " " + option.lastName}
              filterSelectedOptions
              renderInput={(params: any) => (
                <TextField {...params} variant="outlined" label={Labels.ASSOCIATE_EDITOR} />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <Autocomplete
              fullWidth
              className={classes.multiselect}
              id="reviewStatus"
              value={value.uploadBy}
              onChange={(event, newValue) => setValue({ ...value, uploadBy: newValue })}
              options={uplaodUserList}
              getOptionLabel={(option: any) => option.firstName + " " + option.lastName}
              filterSelectedOptions
              renderInput={(params: any) => {
                return <TextField {...params} variant="outlined" label={Labels.UPLOAD_BY_USER} />;
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              variant="outlined"
              margin="normal"
              name="dateFrom"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              value={value.dateFrom}
              onChange={handleChange}
              label={"Upload date from"}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              variant="outlined"
              margin="normal"
              name="dateTo"
              type="date"
              InputLabelProps={{
                shrink: true,
              }}
              value={value.dateTo}
              onChange={handleChange}
              label={"Upload date to"}
              fullWidth
            />
          </Grid>
        </Grid>
        <div className={classes.buttons}>
          <Button onClick={searchManuscripts} variant="contained" color="primary">
            {Labels.SEARCH}
          </Button>
        </div>
      </Paper>
      {resultView(articles)}
    </>
  );
}
